import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import ReactSelect from 'dashboard/components/ReactSelect';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { Template } from 'dashboard/models/template';
import { nameDisplay } from 'lib/utils/template';

interface TemplateSelectorProps {
  templates: Array<Template | InquiryTemplate>;
  value: string;
  handleTemplateSelect: (templateId: string) => void;
  label?: string;
  size?: 'md' | 'sm';
  className?: string;
}

export default ({
  templates,
  value,
  handleTemplateSelect,
  label = 'Template',
  size = 'md',
  className,
}: TemplateSelectorProps) => {
  if (templates.length >= 1) {
    return (
      <div className={className} data-test='template-selector'>
        <FormControlLabel>{label}</FormControlLabel>
        <ReactSelect
          id='template-selector'
          value={value}
          onChange={handleTemplateSelect}
          size={size}
          options={templates
            .map((template) => ({
              label: `${nameDisplay(template)} | ${template.id}`,
              value: template.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))}
        />
      </div>
    );
  } else {
    return <div />;
  }
};
